import {useDetailSidebarContext} from '@/contexts/DetailSidebarContext';
import {useSidebar} from '@/contexts/SidebarContext/SidebarContext';
import {Box} from '@mui/material';
import {Suspense} from 'react';
import {Outlet} from 'react-router-dom';
import {
  SIDEBAR_COLLAPSED_WIDTH,
  SIDEBAR_EXPANDED_WIDTH,
  SUBSIDEBAR_WIDTH,
} from './sidebarWidths';

export const Layout = () => {
  const {selectedCategory, isSubSidebarCollapsed, isSidebarPinned} =
    useSidebar();
  const {isDetailSidebarOpen, detailSidebarWidth, detailSidebarTransition} =
    useDetailSidebarContext();
  const hasSubSidebar = selectedCategory !== null;

  const contentMarginLeft = () => {
    const sidebarWidth = isSidebarPinned
      ? SIDEBAR_EXPANDED_WIDTH
      : SIDEBAR_COLLAPSED_WIDTH;

    if (!hasSubSidebar) {
      return `${sidebarWidth + 8}px`;
    }
    if (isSubSidebarCollapsed) {
      return `${sidebarWidth + 8}px`;
    }
    return `${sidebarWidth + SUBSIDEBAR_WIDTH + 8}px`;
  };

  const contentMarginRight = isDetailSidebarOpen
    ? `${detailSidebarWidth + 16}px`
    : '8px';

  return (
    <Box
      id="main-scroll-container"
      sx={{
        flex: 1,
        marginLeft: contentMarginLeft(),
        marginRight: contentMarginRight,
        marginTop: 1,
        marginBottom: 1,
        height: 'calc(100vh - 16px)',
        overflow: 'auto',
        transition: detailSidebarTransition
          ? 'margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1), margin-right 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
          : 'margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        borderRadius: 2,
        border: theme => `1px solid ${theme.palette.divider}`,
        backgroundColor: theme => theme.palette.background.default,
      }}
    >
      <Suspense fallback={null}>
        <Outlet />
      </Suspense>
    </Box>
  );
};
